<template lang="pug">
  .youtube-player(
    ref="domPlayer"
    draggable="true"
    v-if="currentSentence.youtube_uid"
    v-show="display.youtubePlayer"
    )
    .has-position-relative
      youtube(
      :video-id="currentSentence.youtube_uid"
      :player-vars="playerVars"
      ref="youtube"
      @ended="ended"
      @cued="cued"
      @buffering="buffering"
      @ready="delayedPlayRange"
      @paused="pausedVideo"
      @playing="playingVideo")
    .actions
      button.button.is-dark.move-button(@mousedown="updatePos($event)")
        b-icon(icon="remove")
      button.button.is-rounded.is-dark.close-button(@click="toggleFilter()")
        b-icon(icon="close")

</template>

<script>
  import {nodeApi} from "@/config";
  import _ from "lodash";
  import {mapGetters} from 'vuex'

  export default {
    name: "YoutubePlayer",
    components: {
    },
    props: [
      'sentence',
      'value'
    ],
    computed: {
      ...mapGetters(['currentSentence', 'display', 'sentencePlayerRev']),
      player() {
        if (!this.$refs.youtube) {
          return null;
        }
        return this.$refs.youtube.player
      },
    },
    data() {
      return {
        playerVars: {
          autoplay: 1,
          color: 'white'
        },
        playing: false,
        pausesQueue: [],
      };
    },
    watch: {
      currentSentence() {
        console.log('sentence changed!');
        this.$store.commit('editDisplay', {...this.display, youtubePlayer: true});
        this.delayedPlayRange();
        // this.playRange();
      },
      sentencePlayerRev() {
        console.log('forcing play');
        this.$store.commit('editDisplay', {...this.display, youtubePlayer: true});
        this.playRange();
      }
    },
    mounted() {

    },
    methods: {
      delayedPlayRange() {
        console.log('■ delayedPlayRange');
        setTimeout(() => {
          this.playRange()
        }, 700);
      },
      playRange() {
        if (this.$refs.youtube && this.$refs.youtube.player) {
          const { player } =  this.$refs.youtube;
          const { currentSentence } = this
          let tm;
          player.seekTo(currentSentence.starts_at, true)
          while (tm = this.pausesQueue.shift()) {
            clearTimeout(tm);
          }
          if (!this.playing) {
            player.playVideo();
          }
          // this.pausesQueue.push(setTimeout(() => {
          //   player.pauseVideo();
          // }, (currentSentence.ends_at-currentSentence.starts_at)*1000))
        } else {
          console.log('Player not loaded..')
        }
      },
      pausedVideo() {
        console.log('■ PAUSE');
        this.playing = false;
      },
      cued() {
        console.log('■ cued');
      },
      ended() {
        console.log('■ ended');
      },
      buffering() {
        console.log('■ buffering');
        // this.delayedPlayRange();
      },
      playingVideo() {
        console.log('■ playing');
        this.playing = true;
        this.player.getCurrentTime().then((time) => {
          console.log('time is: ', time)

          if (time < this.currentSentence.ends_at) {
            this.pausesQueue.push(setTimeout(() => {
              this.player.pauseVideo();
            }, (this.currentSentence.ends_at-this.currentSentence.starts_at)*1000+400))
          }
        })
      },
      toggleFilter() {
        this.player.pauseVideo();
        this.$store.commit('editDisplay', {...this.display, youtubePlayer: !this.display.youtubePlayer})
      },
      updatePos(ev) {
        const e = ev || window.event;
        e.preventDefault();
        let pos3 = e.clientX;
        let pos4 = e.clientY;

        const elementDrag = (e) => {
          e = e || window.event;
          e.preventDefault();
          // calculate the new cursor position:
          const pos1 = pos3 - e.clientX;
          const pos2 = pos4 - e.clientY;
          pos3 = e.clientX;
          pos4 = e.clientY;
          // set the element's new position:
          this.$refs.domPlayer.style.top = (this.$refs.domPlayer.offsetTop - pos2) + "px";
          this.$refs.domPlayer.style.left = (this.$refs.domPlayer.offsetLeft - pos1) + "px";
        }

        const closeDragElement = () => {
          // stop moving when mouse button is released:
          document.onmouseup = null;
          document.onmousemove = null;
        }

        console.log(ev)
        // get the mouse cursor position at startup:
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;

      }
    }
  };
</script>

<style lang="scss">
  @import "colors";
  $matchYellow: #ffdd57;

  .youtube-player {
    overflow: hidden;
    position: fixed;
    bottom: 10%;
    right: 2%;
    width: 520px;
    height: 295px;
    padding: 25px;
    z-index: 10;
    iframe {
      width: 100% !important;
      height: 100% !important;
    }
    .actions {
      position: relative;
      text-align: right;
    }
    .has-position-relative {
      overflow: hidden;
      width: 476px;
      height: 270px;
      border-radius: 15px;
    }
    .close-button {
      z-index: 100;
      right: -19px;
      margin-right: 0;
      border-radius: 50%;
      width: 35px;
      position: relative;
      top: -277px;
      -webkit-transform: scale(0.8);
      transform: scale(0.8);
    }

    .move-button {
      z-index: 100;
      right: 20px;
      margin-right: 0;
      width: 350px;
      position: relative;
      top: -277px;
      padding: 3px;
      -webkit-transform: scale(1, 0.4);
      transform: scale(1.2, 0.4);
      height: 1.2em;
      .icon {
        height: 1em;
      }
      .mdi {
        transform: scale(2, 1);
      }
    }
  }

  @media screen and (max-width: 425px) {
    body .youtube-player {
      overflow: hidden;
      position: fixed;
      top: 70px;
      bottom: 0;
      left: 0;
      width: 100%;
      right: inherit;
      padding: 0;
      .has-position-relative {
        overflow: hidden;
        width: 100%;
        height: 270px;
        border-radius: 0;
      }
      .move-button {
        display: none;
      }
      .close-button {
        z-index: 100;
        right: 9px;
        margin-right: 0;
        border-radius: 50%;
        width: 35px;
        position: relative;
        top: -261px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/YoutubePlayer.vue